import React from 'react';

import { AnimationDelay } from '../Animation';
import Member from '../Member';
import { MembersDiv } from './styles';
import { getMembers} from '../../services/api';


const Members: React.FC = () => {
  const [members, setMembers] = React.useState<IMember[]>([]);

  const run = React.useCallback(() => {
    getMembers().then(response => {
      const membersR = response.map(
        (member: IMemberGithub) => {
          return {
            userName: member.login,
            urlHTML: member.html_url,
            urlAvatar: member.avatar_url,
          };
        },
      );

      setMembers(membersR);
    });
  }, []);

  React.useEffect(() => {
    run();
  }, [run]);

  return (
    <MembersDiv>
      {members.map((member: IMember, index: number) => (
        <AnimationDelay
          key={`key-amination-delay-member-${index}`}
          delay={(index + 1) * 300}
        >
          <Member {...member} />
        </AnimationDelay>
      ))}
    </MembersDiv>
  );
};

export default Members;
